import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useProductStore } from './../../../ProductProvider';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();

    return (
        <div className={styles.TheComp}>
            <div className="box">
                <div className="info-box">
                    <p className="label">{pageStatus === 'statusA' ? t('H_coming') : t('H_new')}</p>
                    <p className="title">{t('H_title')}</p>
                    <ul className="items">
                        {Array(6)
                            .fill(0)
                            .map((item: any, k: number) => (
                                <li className="item" key={k}>
                                    {t(`H_item${k + 1}`)}
                                </li>
                            ))}
                    </ul>
                </div>
                <div className="img-box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726124413683/hat%20(1).png" />
                </div>
            </div>
            <EfLink
                href={`https://${locale}.ecoflow.com/products/ecoflow-power-hat`}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: t('G_title'),
                    position: `Product Detail_${t('G_title')}`,
                }}
            >
                {t('H_more')} &gt;
            </EfLink>
        </div>
    );
}
